module.exports = __webpack_public_path__ + "static/img/youfubao.179d0cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/coopera/images/youfubao.png
// module id = SQwp
// module chunks = 1